import QcAgentView from './QcAgentView';
import TDMEView from './TDMEView';
import TeamLeadView from './TeamLeadView';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { Roles } from '../auth/constants/AuthConstants';

const CallAudit = () => {
  const userRole = useSelector((state: RootState) => state?.common?.userData?.roles);

  const isQcAgent = userRole?.includes(Roles.ROLE_PX_AUDIT_AGENT);
  const isTeamLead = userRole?.includes(Roles.ROLE_PX_AUDIT_TEAM_LEAD);
  const isTDME = userRole?.includes(Roles.ROLE_CALLING_AGENT);

  const renderView = () => {
    if (isQcAgent) return <QcAgentView />;
    if (isTeamLead) return <TeamLeadView />;
    if (isTDME) return <TDMEView />;
    return null;
  };

  return (
    <div className="flex flex-col items-center justify-center w-full my-5 mx-8">{renderView()}</div>
  );
};

export default CallAudit;
